import { useContext } from 'react';
import { ReviewsContext } from '@app/site/secured/review-manager/provider/ReviewsProvider';

export const useReviewsTools = () => {
	return useContext(ReviewsContext);
};